/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetContactsRequest
 */
export interface GetContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetContactsRequest
     */
    searchstring?: string;
    /**
     * 
     * @type {number}
     * @memberof GetContactsRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsRequest
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof GetContactsRequest
     */
    sort?: string;
}

export function GetContactsRequestFromJSON(json: any): GetContactsRequest {
    return GetContactsRequestFromJSONTyped(json, false);
}

export function GetContactsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchstring': !exists(json, 'searchstring') ? undefined : json['searchstring'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}

export function GetContactsRequestToJSON(value?: GetContactsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchstring': value.searchstring,
        'offset': value.offset,
        'limit': value.limit,
        'sort': value.sort,
    };
}


